import { ResizeOptions } from '@ryusei/code';


/**
 * The default options for the Resize component.
 *
 * @since 0.1.0
 */
export const DEFAULT_OPTIONS: ResizeOptions = {
  horizontal: true,
  vertical  : true,
};
